(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name documents.controller:DocumentsCtrl
   *
   * @description
   *
   */
  angular
    .module('documents')
    .controller('DocumentsCtrl', DocumentsCtrl);

  function DocumentsCtrl($uibModal, $log, HelperService, AlertService, DocumentsService, $translate, GoogleTagManagerHelperService) {
    var vm = this;
    vm.ctrlName = 'DocumentsCtrl';

    vm.selectPeriod = function (item) {
      vm.selectedPeriod = item;

      //var timeRange = HelperService.getDateRange(vm.selectedPeriod.item.key);
      //vm.timelineFilter.dateGTE = timeRange.valueDateGTE;
      //vm.timelineFilter.dateLTE = timeRange.valueDateLTE;

      vm.resetTimelineFilter();
      vm.timelineFilter.dateGTE = HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateGTE;
      vm.timelineFilter.dateLTE = HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateLTE;
      vm.getTimelineItemsGrouped(true);
      GoogleTagManagerHelperService.pushEvent('Documents', 'TabPeriodFilter', $translate.instant(vm.selectedPeriod.item.description));
    };

    vm.resetTimelineFilter = function () {

      vm.searchFilterExpanded = false;
    };


    vm.periodList = [
      {
        item: {
          key: 'today',
          description: 'core.period.today'
        }
      },
      {
        item: {
          key: 'yesterday',
          description: 'core.period.yesterday'
        }
      }, {
        item: {
          key: 'thisWeek',
          description: 'core.period.thisWeek'
        }
      }, {
        item: {
          key: 'thisMonth',
          description: 'core.period.thisMonth'
        }
      }, {
        item: {
          key: 'thisYear',
          description: 'core.period.thisYear'
        }
      }
    ];

    vm.selectedPeriod = vm.periodList[3];

    vm.timelineFilter = {
      page: 0,
      dateGTE: HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateGTE,
      dateLTE: HelperService.getDateRange(vm.selectedPeriod.item.key).valueDateLTE,
      orderBy: 'date desc',
      pageSize: 10
    };
    vm.recompile = {
      timeline: true
    };
    vm.timelineListGrouped = {};


    vm.loadMoreTimelineItemsGrouped = function () {
      vm.getTimelineItemsGrouped(false);

    };

    vm.getTimelineItemsGrouped = function (reset) {

      if (reset) {
        vm.timelineFilter.page = 0;
      } else {
        vm.timelineFilter.page += 1;
      }


      DocumentsService.getDocuments(vm.timelineFilter)
        .then(function (response) {
          vm.timelineListGrouped = HelperService.mergeRowsForTimeline({
            existingData: vm.timelineListGrouped,
            newData: response,
            groupFunction: function (item) {

              var dateYear = new Date(item.date);

              // If we want to group only by date component, without hours
              dateYear.setHours(0, 0, 0, 0);
              return dateYear;
            },
            virtualRowFunction: function (e) {
              var year = new Date(e).getFullYear();
              var virtualRow = {
                isVirtual: true,
                date: year
              };
              $log.debug("virtualRow", e, virtualRow);
              return virtualRow;
            },
            reset: reset,
            reverse: true
          });

          /*
           var todayDateRange = HelperService.getTodayWithoutOffset();
           var yesterdayDateRange = HelperService.getYesterdayWithoutOffset();


           _.forEach(vm.timelineListGrouped.result, function (item) {
           item.dateValue = new Date(item.date);
           if (item.dateValue >= todayDateRange.firstDay && item.dateValue <= todayDateRange.lastDay) {
           item.showText = true;
           item.dateLabel = 'core.period.today';
           }
           else if (item.dateValue >= yesterdayDateRange.firstDay && item.dateValue < yesterdayDateRange.lastDay) {
           item.showText = true;
           item.dateLabel = 'core.period.yesterday';
           }
           else {
           item.showDate = true;
           }
           });
           */
          $log.debug("groupedDocumentsTimeline", vm.timelineListGrouped);
          vm.recompile.timeline = true;
        }).catch(function (error) {
        $log.error(error);
      });
    };

    vm.downloadPdf= function (item) {
      var id = item.id;
      if (item.downloadPdfInProgress) return;
      item.downloadPdfInProgress = true;
      DocumentsService.downloadDocumentPdf(id)
        .then(function(){},
        function(error){
          AlertService.infoAlert({
            text: 'documents.documentDownloadFailed'
          });
        }).finally(function() {
        item.downloadPdfInProgress = false;
      })
    };
    vm.init = function () {
      vm.getTimelineItemsGrouped(true);
    };

    vm.init();
  }
}());
